module.exports = __webpack_public_path__ + "static/media/logo2.2dd0a7b3.png";